import React from 'react'
import Header from './components/Header'

function Contact() {
    return (
        <div className="container">
            <Header />
            contact
        </div>
    )
}

export default Contact
